import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import AppointmentDialog from "./AppointmentDialog";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";
import { AppointmentProvider } from "../context/AppointmentContext";

export default function SiteLayout() {
  const { pathname } = useLocation();
  const [appointmentOpen, setAppointmentOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <AppointmentProvider openAppointment={() => setAppointmentOpen(true)}>
      <div className="min-h-screen flex flex-col bg-white" data-testid="site-layout">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <AppointmentDialog open={appointmentOpen} onOpenChange={setAppointmentOpen} />
        {/* <WhatsAppFab /> */}
      </div>
    </AppointmentProvider>
  );
}
